import { render } from "./ButtonPassword.vue?vue&type=template&id=44b67322"
import script from "./ButtonPassword.vue?vue&type=script&lang=js"
export * from "./ButtonPassword.vue?vue&type=script&lang=js"
script.render = render

export default script